import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createElementVNode as _createElementVNode, renderSlot as _renderSlot, createCommentVNode as _createCommentVNode, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-3548a41c"), n = n(), _popScopeId(), n);
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "component-tree-node-wrapper__horizontal-line" }, [
    /*#__PURE__*/ _createElementVNode("div", { class: "curve" }),
    /*#__PURE__*/ _createElementVNode("div", { class: "line" })
], -1 /* HOISTED */));
const _hoisted_2 = { class: "component-tree-node-wrapper__node__controls" };
const _hoisted_3 = {
    key: 0,
    class: "fa-solid fa-chevron-down"
};
const _hoisted_4 = {
    key: 1,
    class: "fa-solid fa-chevron-up"
};
const _hoisted_5 = { key: 0 };
import { useBuiltComponent } from "src/shared/store/component-built/composables";
import { computed, ref, useSlots } from "vue";
import ComponentDisplayName from "../ComponentDisplayName.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'ComponentTreeNode',
    props: {
        tree: {},
        activeComponentIds: {},
        isLastChild: { type: Boolean },
        isTop: { type: Boolean, default: false },
        callbackFunction: {}
    },
    setup(__props) {
        const props = __props;
        const isActive = computed(() => {
            if (!props.activeComponentIds) {
                return false;
            }
            return props.activeComponentIds.has(props.tree.componentId);
        });
        const { builtComponent } = useBuiltComponent(props.tree.componentId);
        const hasChildren = computed(() => {
            return props.tree.children.length > 0;
        });
        const isExpanded = ref(true);
        const slots = useSlots();
        const hasPrefixSlot = slots.prefix !== undefined;
        const hasSuffixSlot = slots.suffix !== undefined;
        const toggleExpansion = () => {
            if (!hasChildren.value) {
                return;
            }
            isExpanded.value = !isExpanded.value;
        };
        return (_ctx, _cache) => {
            const _component_ComponentTreeNode = _resolveComponent("ComponentTreeNode", true);
            return (_unref(builtComponent))
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: _normalizeClass(["component-tree-node-wrapper", {
                            'component-tree-node-wrapper--last-child': props.isLastChild,
                            'component-tree-node-wrapper--top': props.isTop,
                        }])
                }, [
                    _hoisted_1,
                    _createElementVNode("div", {
                        class: _normalizeClass(["component-tree-node-wrapper__node", {
                                'component-tree-node-wrapper--expandable': hasChildren.value || _ctx.callbackFunction,
                            }])
                    }, [
                        _createElementVNode("div", {
                            class: _normalizeClass(["component-tree-node-wrapper__node__name", {
                                    'component-tree-node-wrapper__node__name--active': isActive.value,
                                }]),
                            onClick: _cache[0] || (_cache[0] = ($event) => (props.callbackFunction
                                ? props.callbackFunction(_unref(builtComponent))
                                : toggleExpansion()))
                        }, [
                            hasPrefixSlot
                                ? _renderSlot(_ctx.$slots, "prefix", {
                                    key: 0,
                                    componentId: _ctx.tree.componentId
                                })
                                : _createCommentVNode("v-if", true),
                            _createVNode(ComponentDisplayName, {
                                "component-id": _unref(builtComponent).id,
                                "tag-name": _unref(builtComponent).isRoot() ? 'h2' : 'span'
                            }, null, 8 /* PROPS */, ["component-id", "tag-name"]),
                            hasSuffixSlot
                                ? _renderSlot(_ctx.$slots, "suffix", {
                                    key: 1,
                                    componentId: _ctx.tree.componentId
                                })
                                : _createCommentVNode("v-if", true)
                        ], 2 /* CLASS */),
                        _createElementVNode("div", _hoisted_2, [
                            _renderSlot(_ctx.$slots, "line", {
                                componentId: _ctx.tree.componentId
                            })
                        ]),
                        (_ctx.tree.children.length)
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 0,
                                class: "expand-icon-wrapper",
                                onClick: _cache[1] || (_cache[1] = ($event) => (toggleExpansion()))
                            }, [
                                (isExpanded.value)
                                    ? (_openBlock(), _createElementBlock("i", _hoisted_3))
                                    : (_openBlock(), _createElementBlock("i", _hoisted_4))
                            ]))
                            : _createCommentVNode("v-if", true)
                    ], 2 /* CLASS */),
                    (isExpanded.value)
                        ? (_openBlock(), _createElementBlock("ul", _hoisted_5, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tree.children, (child, index) => {
                                return (_openBlock(), _createElementBlock("li", {
                                    key: child.componentId
                                }, [
                                    _createVNode(_component_ComponentTreeNode, {
                                        tree: child,
                                        "is-last-child": index === _ctx.tree.children.length - 1,
                                        "active-component-ids": _ctx.activeComponentIds,
                                        callbackFunction: props.callbackFunction
                                    }, {
                                        prefix: _withCtx(({ componentId }) => [
                                            _renderSlot(_ctx.$slots, "prefix", { componentId: componentId })
                                        ]),
                                        line: _withCtx(({ componentId }) => [
                                            _renderSlot(_ctx.$slots, "line", { componentId: componentId })
                                        ]),
                                        _: 2 /* DYNAMIC */
                                    }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["tree", "is-last-child", "active-component-ids", "callbackFunction"])
                                ]));
                            }), 128 /* KEYED_FRAGMENT */))
                        ]))
                        : _createCommentVNode("v-if", true)
                ], 2 /* CLASS */))
                : _createCommentVNode("v-if", true);
        };
    }
});
